import clsx from 'clsx';
import type { Control, FieldValues, Path } from 'react-hook-form';
import LabelT from '../Label/LabelT';
import InputT from './InputT';

type InputProps<T extends FieldValues> = {
  id: string;
  label: string;
  control?: Control<T>;
  field?: Path<T>;
  labelClassName?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  imgSrc?: string;
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export function RadioInputT<T extends FieldValues>({
  id,
  label,
  control,
  field,
  labelClassName,
  onChange,
  imgSrc,
  ...restParams
}: InputProps<T>) {
  const { className, name, checked } = restParams || {};

  let defaultClasses = [
    'flex',
    'items-center',
    'justify-start',
    'font-light',
    'text-sm',
    'my-3',
    'cursor-pointer',
    'select-none',
    'appearance-none',
    'relative',
  ];
  // If className contains a my-* ( margin ) class, remove my-3 from defaultClasses, otherwise the my-3 is always overwritten the my-* class that is coming from the parent component
  if (className?.includes('my-')) {
    defaultClasses = defaultClasses.filter((style) => !style.startsWith('my-'));
  }

  return (
    <div className={clsx([...defaultClasses, className])}>
      <InputT
        id={id}
        type='radio'
        name={name}
        field={field}
        control={control}
        options={{
          onChange,
        }}
        checked={checked}
        className='cursor-pointer'
      />
      {label && (
        <div className='flex items-center pl-2'>
          {imgSrc && (
            <img
              src={imgSrc}
              alt={label}
              className='inline-flex w-4 h-4 mr-1'
            />
          )}
          <LabelT htmlFor={id} text={label} className={`${labelClassName}`} />
        </div>
      )}
    </div>
  );
}

export default RadioInputT;
